import axios from "axios";
import { ADMIN_BASE } from "./adminBase";

// Runtime API base: on Emergent-managed hosts and local dev use the configured backend URL;
// on a custom domain (e.g. www.trainingbasket.in) call the API same-origin — the domain's
// edge already proxies /api to the backend, so no CORS and first-party cookies.
const EMERGENT_HOST = /(^|\.)(emergentagent\.com|emergent\.host)$/;
const host = typeof window !== "undefined" ? window.location.hostname : "";
export const API_BASE = (!host || EMERGENT_HOST.test(host) || host === "localhost" || host === "127.0.0.1")
  ? process.env.REACT_APP_BACKEND_URL
  : window.location.origin;

export const API = `${API_BASE}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const ws = localStorage.getItem("tb_workspace");
  if (ws) config.headers["X-Workspace"] = ws;
  return config;
});

// Auth endpoints whose 401/403 must surface raw to their forms (no refresh, no redirect).
const NO_REFRESH = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/register", "/admin/gate", "/auth/otp/", "/auth/forgot-password", "/auth/reset-password", "/auth/check-email"];

let refreshing = null;
function refreshSession() {
  refreshing = refreshing || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true })
    .finally(() => { refreshing = null; });
  return refreshing;
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const cfg = error?.config || {};
    const url = cfg.url || "";
    if (error?.response?.status !== 401 || cfg.__retried || NO_REFRESH.some((p) => url.includes(p))) {
      return Promise.reject(error);
    }
    cfg.__retried = true;
    try {
      await refreshSession();
      return api(cfg);
    } catch (e) {
      const path = window.location.pathname;
      // Anonymous public visitors (auth/me probe) and the QA portal must not be bounced to login.
      if (!url.includes("/auth/me") && !path.startsWith("/qa") && !path.endsWith("/login")) {
        window.location.href = path.startsWith(ADMIN_BASE) ? `${ADMIN_BASE}/login` : "/login";
      }
      return Promise.reject(error);
    }
  }
);

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) {
    const status = error?.response?.status;
    if (status && status >= 500) return "The payment/service gateway is temporarily unavailable — please try again in a moment or contact support.";
    return error?.message || "Something went wrong. Please try again.";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
